export default "/images/vendor/flag-icons/flags/1x1/tv.svg?57ef8775a287d9d53d50261e049fb49a";